'use client'

import CreationToolStep from 'creation/src/creation-tools/types/steps'
import { NexaBlack } from '@/styles/fonts'
import { cn } from '@/util/cn'
import { subtitle } from './presentation/typography'
import { useCreationStore } from './store/provider'
import { useCurrentStep } from './use-creation-next-step'

/**
 * Ported from legacy components/breadcrumbs.tsx. Active-step resolution is
 * delegated to `useCurrentStep` (use-creation-next-step.ts) rather than
 * re-implemented inline, so its substring-matching quirk (documented there)
 * stays in one place for sub-project 3 to fix.
 */
const Breadcrumbs = () => {
    const steps = useCreationStore((state) => state.steps)
    const activeStep = useCurrentStep(steps)

    if (steps.length <= 1) {
        return null
    }

    return (
        <div className="pointer-events-none sticky bottom-0 box-border w-full shrink-0 grow-0 bg-giphyBlack py-[15px] text-center">
            {steps.map((step, i) => {
                const active = step === activeStep
                return (
                    <div
                        key={step}
                        className={cn('mx-[15px] inline-block', active ? 'text-white' : 'text-giphyLightGrey')}
                    >
                        <div
                            className={cn(
                                'mr-[12px] inline-block h-[32px] w-[32px] rounded-[2px] text-center text-[15px] leading-[34px] antialiased',
                                NexaBlack.className,
                                active ? 'bg-white text-black' : 'bg-black text-white'
                            )}
                        >
                            {i + 1}
                        </div>
                        <span className={cn(subtitle, 'm-0')}>{CreationToolStep.label(step)}</span>
                    </div>
                )
            })}
        </div>
    )
}

export default Breadcrumbs
